import { createContext, useContext } from 'react';

const NodeIdContext = createContext<string | null>(null);

/** Gives node content (handles, resizer) the id of the node they are rendered in. */
export const NodeIdProvider = NodeIdContext.Provider;

/** Id of the surrounding node, or null outside a node. */
export const useNodeId = (): string | null => useContext(NodeIdContext);
